import { render, staticRenderFns } from "./contratos_faturamento.vue?vue&type=template&id=6f876c98"
import script from "./contratos_faturamento.vue?vue&type=script&lang=js"
export * from "./contratos_faturamento.vue?vue&type=script&lang=js"
import style0 from "./contratos_faturamento.vue?vue&type=style&index=0&id=6f876c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports